module.exports = __webpack_public_path__ + "img/icon_map_4_off_110.fc979e25.png";